import React, { useRef } from 'react'

import Grid from '../../../../components/Grid'
import SignUpForm from './SignUpForm'
import { content } from './data'

import ELocale from '../../../../types/locales'
import { useCallbackWhenVisible } from '../../../../utils/gtm/useCallbackWhenVisible'
import trackEvent from '../../../../utils/gtm/trackEvent'
import { getEecPromoImpressionEventForNewsletter } from '../../../../utils/gtm/eecPromoImpressionEvents'

const NewsletterArea: React.FC<{ locale: ELocale }> = (props) => {
  const money = props.locale === ELocale.DE_CH ? 'CHF 15.00' : '10 €'
  const impressionEl = useRef(null)

  useCallbackWhenVisible(
    impressionEl,
    (pathName) => trackEvent(getEecPromoImpressionEventForNewsletter(pathName)),
    true,
  )

  return (
    <Grid.Container className="mt-32" ref={impressionEl}>
      <Grid.Row>
        <Grid.Col width={12} className="text-center sm:text-left">
          <p className="font-bold">Newsletter abonnieren – {money} Gutschein erhalten</p>
        </Grid.Col>
        <Grid.Col width={12} sm={6} className="text-center sm:text-left mt-8 sm:pr-32">
          <p>
            {content.description_start}
            {money}
            {content.description_end}
          </p>
        </Grid.Col>
        <Grid.Col width={12} sm={6} className="mt-24 sm:mt-8">
          <SignUpForm locale={props.locale} />
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  )
}

export { NewsletterArea as default }
